import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Grid, Row, Col, Table, Form, FormGroup, ControlLabel, ButtonToolbar, Button } from 'react-bootstrap';
import DatePicker from 'react-16-bootstrap-date-picker';

import { HandleMessage } from './HandleMessage';
import { EditionAPI } from '../api/datamanager/EditionAPI';

class DatePickerButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            cache: props.value,
            isFocused: false
        };
    }

    onClick() {
        const { cache, isFocused } = this.state;
        const { value, onFocus, onBlur } = this.props;

        cache === value && isFocused ? onBlur() : onFocus();

        this.setState({
            cache: value,
            isFocused: cache !== value || !isFocused
        });
    }

    render() {
        const { ref } = this.props;

        return (
            <Button onClick={() => this.onClick()} ref={ref}>ESCOLHER DATA</Button>
        );
    }
}

export class EditionSelector extends Component {
    static contextTypes = {
        selectedProvider: PropTypes.string,
        edition: PropTypes.object,
        editionsModifications: PropTypes.object,
        setEditionsModifications: PropTypes.func
    }

    constructor(props) {
        super(props);

        const date = new Date();
        date.setHours(12);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);

        this.state = {
            commands: {
                editions: new EditionAPI()
            },
            date: {
                string: date.toISOString(),
                day: date.getDate(),
                month: date.getMonth() + 1,
                year: date.getFullYear(),
            },
            render: {
                months: this.getMonthsToRender(date),
                days: this.getMonthDays(date),
                networkModificationsDays: [],
                planningModificationsDays: []
            },
            labels: {
                months: {
                    "0": "JAN",
                    "1": "FEV",
                    "2": "MAR",
                    "3": "ABR",
                    "4": "MAI",
                    "5": "JUN",
                    "6": "JUL",
                    "7": "AGO",
                    "8": "SET",
                    "9": "OUT",
                    "10": "NOV",
                    "11": "DEZ",
                }
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            }
        };
    }

    componentDidMount() {
        const { edition, editionsModifications } = this.context;
        const { date } = this.state;

        if(null === editionsModifications || undefined === editionsModifications) {
            this.getEditionsModifications(date.month, date.year);
        }
        else {
            this.setEditionsModifications(editionsModifications);
        }

        if (null !== edition && undefined !== edition && null !== edition.date && undefined !== edition.date) {
            this.setDate(edition.date);
        }
    }

    // --------------------

    getEditionsModifications(month, year) {
        const { selectedProvider } = this.context;
        const { commands } = this.state;

        let selectedProviderId = '';
        if (selectedProvider !== undefined) {
            selectedProviderId = selectedProvider.split(':')[0];
        }

        commands.editions.getModifications(month, year, selectedProviderId)
            .then((a) => this.getModificationsCallback(JSON.parse(a)))
            .catch(() => this.errorCallback("Ocorreu um erro a ler as modificações para o mês selecionado"));
    }

    // --------------------

    getModificationsCallback(editionsModifications) {
        this.context.setEditionsModifications(editionsModifications);
        this.setEditionsModifications(editionsModifications);
    }

    errorCallback(message) {
        this.setState({
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    // --------------------

    getMonthDays(date) {
        return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    }

    getMonthsToRender(date) {
        const output = [];
        const tempDate = new Date(date.getFullYear(), date.getMonth(), 1);

        let i = 0;
        do {
            const monthToRender = date.getMonth() + (i - 4);

            if (0 > monthToRender) {
                tempDate.setMonth(12 + monthToRender);
                tempDate.setFullYear(date.getFullYear() - 1);
            }
            else if (11 < monthToRender) {
                tempDate.setMonth(monthToRender - 12);
                tempDate.setFullYear(date.getFullYear() + 1);
            }
            else {
                tempDate.setMonth(monthToRender);
                tempDate.setFullYear(date.getFullYear());
            }

            output.push({
                number: tempDate.getMonth(),
                year: tempDate.getFullYear()
            });
        } while (++i < 9);

        return output;
    }

    setDate(newDate) {
        const { date, render } = this.state;

        const currentMonth = date.month;
        const currentYear = date.year;

        date.string = newDate.toISOString();
        date.day = newDate.getDate();
        date.month = newDate.getMonth() + 1;
        date.year = newDate.getFullYear();

        if (currentMonth !== date.month || currentYear !== date.year) {
            this.getEditionsModifications(date.month, date.year);
        }

        render.months = this.getMonthsToRender(newDate);
        render.days = this.getMonthDays(newDate);

        this.setState({
            date: date,
            render: render
        });
    }

    setEditionsModifications(editionsModifications) {
        const { render } = this.state;

        render.networkModificationsDays = editionsModifications.network;
        render.planningModificationsDays = editionsModifications.planning;

        this.setState({
            render: render
        });
    }

    // --------------------

    onChangeValue(value) {
        const { edition } = this.context;
        const { date } = this.state;

        if (date.string !== value) {
            const newDate = new Date(value);

            this.setDate(newDate);
            edition.update(newDate);
        }
    }

    onChangeDay(day) {
        const { date } = this.state;

        this.onChangeValue(new Date(date.year, date.month - 1, day, 12, 0, 0).toISOString());
    }

    onChangeMonth(month) {
        const { date } = this.state;
        const daysInMonth = new Date(month.year, month.number, 0).getDate();

        let day = date.day;
        if (daysInMonth < day) {
            day = daysInMonth;
        }

        this.onChangeValue(new Date(month.year, month.number, day, 12, 0, 0).toISOString());
    }

    onNextMonthClick() {
        const { date } = this.state;
        const month = {
            number: date.month,
            year: date.year
        };

        if (11 < month.number) {
            month.number = month.number - 12;
            month.year = month.year + 1;
        }

        this.onChangeMonth(month);
    }

    onPreviousMonthClick() {
        const { date } = this.state;
        const month = {
            number: date.month - 2,
            year: date.year
        };

        if (0 > month.number) {
            month.number = 12 + month.number;
            month.year = month.year - 1;
        }

        this.onChangeMonth(month);
    }

    onTodayClick() {
        const date = new Date();
        date.setHours(12);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);

        this.onChangeValue(date.toISOString())
    }

    // --------------------

    renderMonthDays(day, render) {
        const output = [];

        let i = 1;
        do {
            const dayCopy = i;
            const hasNetworkModification = render.networkModificationsDays.includes(i);
            const hasPlanningModification = render.planningModificationsDays.includes(i);

            let renderClasses = `${i === day ? "selected" : ""}`;
            if (hasNetworkModification && hasPlanningModification) {
                renderClasses = `${renderClasses} both-modification`;
            }
            else if (hasNetworkModification) {
                renderClasses = `${renderClasses} network-modification`;
            }
            else if (hasPlanningModification) {
                renderClasses = `${renderClasses} planning-modification`;
            }

            output.push(
                <td key={`day-${i}`}
                    className={`edition-selector-day ${renderClasses}`}
                    onClick={() => this.onChangeDay(dayCopy)}>
                    <span>{10 > i ? `0${i}` : i}</span>
                </td>
            );
        } while (++i <= render.days);

        return (
            <tr className="text-align-center">
                {output}
            </tr>
        );
    }

    render() {
        const { date, render, labels, message } = this.state;

        return (
            <div>
                <Grid fluid>
                    <Row>
                        <Col sm={12}>
                            <div className="edition-selector">
                                <div className="edition-selector-desktop">
                                    <ButtonToolbar className="pull-right">
                                        <Button onClick={() => this.onTodayClick()}>HOJE</Button>
                                        <DatePicker
                                            id="editionDatePicker"
                                            value={date.string}
                                            onChange={(e) => this.onChangeValue(e)}
                                            customControl={<DatePickerButton />} />
                                    </ButtonToolbar>

                                    <Table className="edition-selector-months">
                                        <tbody>
                                            <tr className="text-align-center">
                                                <td className="edition-selector-navigation width-1p"
                                                    onClick={() => this.onPreviousMonthClick()}>
                                                    &lt;
                                                </td>
                                                {
                                                    render.months.map(month =>
                                                        <td key={`${month.year}-${month.number}`}
                                                            className={`edition-selector-month ${month.number === date.month - 1 ? "selected" : ""}`}
                                                            onClick={() => this.onChangeMonth(month)}>
                                                            <div>{month.year}</div>
                                                            <div>{labels.months[month.number]}</div>
                                                        </td>
                                                    )
                                                }
                                                <td className="edition-selector-navigation width-1p"
                                                    onClick={() => this.onNextMonthClick()}>
                                                    &gt;
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>

                                    <Table className="edition-selector-days">
                                        <tbody>
                                            {this.renderMonthDays(date.day, render)}
                                        </tbody>
                                    </Table>
                                </div>

                                <Form onSubmit={(e) => { e.preventDefault(); }} className="edition-selector-mobile">
                                    <FormGroup controlId="formEditionDate">
                                        <ControlLabel>Data</ControlLabel>
                                        <DatePicker
                                            id="editionDatePicker"
                                            dateFormat="YYYY/MM/DD"
                                            value={date.string}
                                            placeholder="Introduza a Data da Edição"
                                            onChange={(e) => this.onChangeValue(e)} />
                                    </FormGroup>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </Grid>

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/EditionSelector.js